<div class="user-profile-menu" [ngClass]="toggleMenuFlag ? 'active' : ''">
  <a class="user-icon-2" id="dropdownMenuButtonUser" (click)="toggleMenu()"></a>
  <ul class="user-profile-list">
    <li *ngIf="profiledata">
      <div class="profile-excerpt">
        <span class="name" *ngIf="profiledata.name"
          ><b>{{ profiledata.name.first }} {{ profiledata.name.last }}</b></span
        >
        <span class="phone" *ngIf="profiledata.mobile">{{ profiledata.mobile }}</span>
        <a routerLink="/home/profile" class="edit-profile" (click)="closeMenu()">تعديل</a>
      </div>
    </li>
    <li class="my-cars">
      <a routerLink="/home/wallet" (click)="closeMenu()">
        رصيد سبيرو
      </a>
    </li>
    <li class="my-cars">
      <a routerLink="/home/my-cars" (click)="closeMenu()">
        سياراتي
      </a>
    </li>
    <li class="static-pages">
      <a href="https://support.speero.net" target="_blank" (click)="closeMenu()">الاسئلة الشائعة</a>
      <a href="{{ appURL }}/payment-methods" (click)="closeMenu()">طرق الدفع</a>
      <a href="{{ appURL }}/contact-us" (click)="closeMenu()">اتصل بنا</a>
      <a href="{{ appURL }}/terms-and-conditions" (click)="closeMenu()">الشروط والاحكام</a>
      <!-- <a>باقات الاسعار</a> -->
      <a href="{{ appURL }}/about-us" (click)="closeMenu()">عن سبيرو</a>
    </li>
    <li>
      <a class="logout" (click)="logOut()" (click)="closeMenu()">تسجيل خروج</a>
    </li>
  </ul>
</div>
